import type { ReactNode } from 'react';
import { toast, TOAST_Z_INDEX } from './toast';

/** @deprecated Prefer TOAST_Z_INDEX from utils/toast — kept for existing imports */
export const BILLING_TOAST_Z = TOAST_Z_INDEX;

export type BillingToastOptions = {
  duration?: number;
  key?: string;
};

function durationMs(durationOrOpts?: number | BillingToastOptions, fallback = 4): number {
  if (typeof durationOrOpts === 'number') return durationOrOpts * 1000;
  if (durationOrOpts?.duration != null) return durationOrOpts.duration * 1000;
  return fallback * 1000;
}

/**
 * Toasts facturation : délègue à `toast` (react-toastify).
 */
export const billingToast = {
  success: (content: ReactNode, durationOrOpts: number | BillingToastOptions = 4) =>
    toast.success(content, durationMs(durationOrOpts, 4)),
  error: (content: ReactNode, durationOrOpts: number | BillingToastOptions = 5) =>
    toast.error(content, durationMs(durationOrOpts, 5)),
  info: (content: ReactNode, durationOrOpts: number | BillingToastOptions = 4) =>
    toast.info(content, durationMs(durationOrOpts, 4)),
  warning: (content: ReactNode, durationOrOpts: number | BillingToastOptions = 4) =>
    toast.warning(content, durationMs(durationOrOpts, 4)),
  loading: (content: ReactNode, _durationOrOpts?: number | BillingToastOptions) =>
    toast.loading(content),
};
